import React, { memo } from "react";
import PropTypes from "prop-types";
import CONFIG from "../../../Config";
import { get } from "lodash-es";

const AzureCoogBlock = ({ strings, path, redirectTo }) => {
    const separatorLabel = get(strings, "separator.or.label", "OU");
    const buttonText = get(strings, "link.connectAzure.label", "Se connecter avec Microsoft Azure");
    const authUrl = `${CONFIG.apiBaseUrl}${path}?redirectURL=${redirectTo}`;

    const styles = {
        container: { paddingTop: "1em" },
    };

    return (
        <>
            <div className="separator or">
                <span className="label">{separatorLabel}</span>
            </div>
            <div className="external-provider-block" style={styles.container}>
                <a className="azure-button" href={authUrl}>
                    <span className="azure-button__icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 19.68 15.24">
                            <path
                                d="M9.105 14.43l4.642-.82.043-.01-2.387-2.84a403.945 403.945 0 0 1-2.387-2.853c0-.014 2.465-6.802 2.479-6.826.004-.008 1.682 2.888 4.066 7.02l4.09 7.09.031.054-7.587-.001-7.587-.001 4.597-.812zM0 13.566c0-.004 1.125-1.957 2.5-4.34L5 4.893l2.913-2.445C9.515 1.104 10.83.002 10.836 0a.512.512 0 0 1-.047.118L7.625 6.903l-3.107 6.663-2.259.003c-1.242.002-2.259 0-2.259-.004z"
                                fill="#0089d6"
                            />
                        </svg>
                    </span>
                    <span className="azure-button__text">{buttonText}</span>
                </a>
            </div>
        </>
    );
};

AzureCoogBlock.propTypes = {
    strings: PropTypes.object.isRequired,
    path: PropTypes.string.isRequired,
    redirectTo: PropTypes.string.isRequired,
};

export default memo(AzureCoogBlock);
